import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.user-labels.move', {
        url: '/move',
        params: {users: [],labels:[]},
        views: {
            '@company': 'companyUserLabelMembersMove'
        },
        resolve: {
            users,
            labels,
        },
    });
}

/** @ngInject */
function users($stateParams) {
    return $stateParams.users;
}

/** @ngInject */
function labels($stateParams) {
   return $stateParams.labels;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/move/move-users-to-label.state.js